<template>
  <base-cell
    v-slot:default="{hover}"
    @click="$emit('click', item)"
  >
    <base-avatar
      v-if="item.profile_pic"
      :size="44"
      :img="item.profile_pic"
    />
    <base-avatar
      v-else
      :size="44"
      :username="`${ item.first_name } ${ item.last_name }`"
      :img="item.first_name ? null : '/img/person.png'"
    />
    <div class="d-flex justify-content-center flex-column position-relative group-cell__fullname">
      <base-text class="ml-4 group-cell__name">
        {{ item.display_name_array[0] }}
      </base-text>
      <base-text
        class="ml-4 group-cell__email"
        size="s"
      >
        {{ item.display_name_array[1] }}
      </base-text>
    </div>
    <base-button
      v-if="hover && group && !(group.is_supergroup || group.via_integration)"
      text
      small
      class="ml-auto"
      @click="$emit('delete', item)"
    >
      Remove
    </base-button>
  </base-cell>
</template>

<script>
export default {
  name: 'GroupDetailCell',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    group() {
      if (!this.$store.state.groups.group) {
        return {};
      }
      return this.$store.state.groups.group;
    },
  },
};
</script>

<style lang="scss" scoped>
  .group-cell {
    min-height: 75px;
    background-color: inherit !important;

    &__name {
      min-width: 200px;
      margin-left: 1rem;
    }
    &__fullname{
    font-weight: 500;
    font-size: 14px;
    color: #1B1B1B;

    }
    &__email {
      font-family: 'SilkaLight';

    }
  }
</style>
